import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MaxTemperaturesChartData } from './max-temperatures-chart.model';
import { ProgressBarComponent, TooltipDirective } from '@ui';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'ui-max-temperature-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProgressBarComponent,
    TranslocoDecimalPipe,
    TooltipDirective
  ],
  template: `
    <div class="flex flex-row items-center justify-between gap-x-3">
      <span
        uiTooltip
        [tooltipTitle]="tooltipTitleTemplate"
        [class]="{ 'font-bold': isBold() }"
      >
        {{ item().id && item().name ? item().id + ' - ' + item().name : (item().id || item().name) }}
      </span>
      <div class="flex flex-row items-center gap-x-2">
        <div class="w-32">
          <ui-progress-bar colorClass="bg-orange" [progress]="progress()" />
        </div>
        <span>{{ item().temperature | translocoDecimal:{ minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: false  }  }}º</span>
      </div>
      <ng-template #tooltipTitleTemplate let-data>
        <div class="flex flex-col items-center text-xs mt-0.5">
          <span>{{ item().name }}</span>
        </div>
      </ng-template>
    </div>
  `,
})
export class MaxTemperatureItemComponent {
  item = input.required<MaxTemperaturesChartData>();
  isBold = input<boolean>(false);
  progress = computed(() =>
    this.item().progress <= 100 ? this.item().progress : 100,
  );
}
